import React, { useEffect } from 'react';

import { NavigationWrapper } from '../NavigationWrapper';
import { ReportConfigurationSection } from './ReportConfigurationSection';
import {
  fetchSettings,
  selectSettings,
  useAppDispatch,
  useAppSelector,
} from '../../../state';

import { Loading, SectionsWrapper } from './BuildReports.styles';
import { PowerBiProLicenseSection } from './PowerBiProLicenseSection';
import { QuickViewSection } from './QuickViewSection';

interface IBuildReportsProps {
  userName: string;
}

export const BuildReports: React.FC<IBuildReportsProps> = ({ userName }) => {
  const settingsData = useAppSelector(selectSettings);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (
      !settingsData.settings &&
      !settingsData.loading &&
      !settingsData.failed
    ) {
      dispatch(fetchSettings());
    }
  }, []);

  if (settingsData.loading) {
    return <Loading />;
  }

  if (settingsData.failed) {
    return (
      <SectionsWrapper>
        Error loading data. Please try again later.
      </SectionsWrapper>
    );
  }

  return (
    <>
      <NavigationWrapper />
      <SectionsWrapper disabled={settingsData.saving}>
        {settingsData.settings ? (
          <>
            <ReportConfigurationSection {...settingsData.settings} />
            <PowerBiProLicenseSection
              {...settingsData.settings}
              userName={settingsData.settings.userName || userName}
            />
            <QuickViewSection {...settingsData.settings} />
          </>
        ) : (
          <div>no data</div>
        )}
      </SectionsWrapper>
    </>
  );
};
